/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx, keyframes } from '@emotion/react';
import { N20, N30 } from '@atlaskit/theme/colors';
var AutomationSkeletonContainer = css({
  paddingBlock: "var(--ds-space-025, 2px)"
});
var SkeletonContainer = css({
  marginBlock: "var(--ds-space-100, 8px)",
  marginInline: "var(--ds-space-250, 20px)",
  display: 'flex'
});
var SkeletonIcon = css({
  width: "var(--ds-space-200, 16px)",
  height: "var(--ds-space-200, 16px)",
  display: 'inline-block',
  borderRadius: "var(--ds-space-025, 2px)",
  backgroundColor: 'currentColor',
  border: "var(--ds-space-025, 2px)".concat(" solid transparent"),
  opacity: 0.15
});
var MenuIcon = css({
  width: '24px',
  height: '24px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});
var shimmer = keyframes({
  '0%': {
    backgroundPosition: '-300px 0'
  },
  '100%': {
    backgroundPosition: '2000px 0'
  }
});
var SkeletonText = css({
  width: '85%',
  height: "var(--ds-space-200, 16px)",
  marginTop: "var(--ds-space-050, 4px)",
  marginLeft: "var(--ds-space-150, 12px)",
  animationDuration: '1s',
  animationFillMode: 'forwards',
  animationIterationCount: 'infinite',
  animationName: shimmer,
  animationTimingFunction: 'linear',
  backgroundColor: "var(--ds-skeleton, ".concat(N30, ")"),
  backgroundImage: "linear-gradient(to right, ".concat("var(--ds-skeleton, ".concat(N30, ")"), " 10%, ", "var(--ds-skeleton-subtle, ".concat(N20, ")"), " 30%, ", "var(--ds-skeleton, ".concat(N30, ")"), " 50%)"),
  backgroundRepeat: 'no-repeat'
});
var SkeletonLine = function SkeletonLine() {
  return jsx("div", {
    css: SkeletonContainer
  }, jsx("div", {
    css: MenuIcon
  }, jsx("div", {
    css: SkeletonIcon
  })), jsx("div", {
    css: SkeletonText
  }));
};
var getSkeletonLines = function getSkeletonLines(lineCount) {
  var skeletonLines = [];
  for (var i = 0; i < lineCount; i++) {
    skeletonLines.push(jsx(SkeletonLine, {
      key: "skeleton-line-".concat(i)
    }));
  }
  return skeletonLines;
};
export var SkeletonOld = function SkeletonOld(props) {
  var _props$lineCount = props.lineCount,
    lineCount = _props$lineCount === void 0 ? 5 : _props$lineCount;
  return (
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    jsx("div", {
      css: AutomationSkeletonContainer
    }, getSkeletonLines(lineCount))
  );
};